var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeftLong = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.8 10.5 13 7.363 11.61 6 6 11.5l5.61 5.5L13 15.637 9.8 12.5H18v-2z"
})));
export { SvgArrowLeftLong as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowLeftLong.1edb6e89.svg";